import { 
  SET_GAME_DETAIL, 
  SET_LOADING, 
  SET_ERROR 
} from '../actions/gameDetailActions';

const initialState = {
  gameDetail: null,
  loading: false,
  error: null
};

const gameDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_GAME_DETAIL:
      return {
        ...state,
        gameDetail: action.payload,
        error: null
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
        gameDetail: null
      };
    default:
      return state;
  }
};

export default gameDetailReducer; 